import Signup from '@/components/pages/Signup.vue';
import EmailConfirmed from '@/components/pages/EmailConfirmed.vue';
import InstagramVerify from '@/components/pages/InstagramVerify.vue';
import TwitterVerify from '@/components/pages/TwitterVerify.vue';
import EmailSignin from '@/components/pages/EmailSignin.vue';
import TemporaryTokenSignin from '@/components/pages/TemporaryTokenSignin.vue';
import EmailConfirm from '@/components/pages/EmailConfirm.vue';
import Signout from '@/components/pages/Signout.vue';
import ProfileEdit from '@/components/pages/ProfileEdit.vue';
import Help from '@/components/pages/Help.vue';
import CampaignScoped from '@/components/pages/CampaignScoped.vue';
import SessionError from '@/components/pages/SessionError.vue';
import NotFound from '@/components/pages/NotFound.vue';
import MyPage from '@/components/pages/MyPage.vue';
import PasswordChange from '@/components/pages/PasswordChange.vue';

export default [
  {
    path: '/signup', // サインアップ関連のroutes
    component: Signup,
    children: [
      {
        // Email認証のためのフォーム画面。Instagram, Twitter経由の応募の場合の最初の画面
        path: 'email/:campaignCode',
        component: EmailConfirm
      },
      {
        // 認証メールから送られたリンクの被リンク先。ハッシュ情報を送信してInstagramログインボタンを表示する
        path: 'email_confirmed/:emailVerifyHash',
        component: EmailConfirmed
      },
      {
        // InstagramからcallbackされるURL。Instagramからパラメータで送られてくる認証情報をバックエンドに送信する
        path: 'instagram_callback',
        component: InstagramVerify
      },
      {
        // TwitterからcallbackされるURL。Twitterからパラメータで送られてくる認証情報をバックエンドに送信する
        path: 'twitter_callback',
        component: TwitterVerify
      },
      {
        // サインアップ手続き中に表示するセッションエラー画面。タイムアウトだよーって言わなあかん
        path: 'error/session',
        component: SessionError
      }
    ]
  },
  {
    path: '/cp/:campaignCode',
    component: CampaignScoped,
    meta: {
      requiresCampaignHash: true
    },
    children: [
      {
        // ユーザ情報画面
        path: 'me/edit',
        component: ProfileEdit,
        meta: {
          requiresToken: true
        }
      },
      {
        // お問い合わせ画面
        path: 'me/help',
        component: Help
      },
      {
        // 何枚目の作品を意味するルーティング。記憶することで「戻る」などの動作に対応できるようになる
        path: 'me/:tabIndex',
        component: MyPage,
        meta: {
          requiresToken: true
        }
      },
      {
        // メイン画面のURL。とはいえコンポーネント自体は、外枠と中身のコンテンツを呼び出すことが役割
        path: 'me',
        component: MyPage,
        meta: {
          requiresToken: true
        }
      },
      {
        // ログイン画面
        path: 'login',
        component: EmailSignin
      },
      {
        // 管理者一時トークンログイン画面
        path: 'temporary_token_login',
        component: TemporaryTokenSignin
      },
      {
        // ログアウト
        path: 'logout',
        component: Signout
      },
      {
        // パスワード変更処理を行ったあとの、メール内リンクの被リンク先
        path: 'password_init/:passwordCode',
        component: PasswordChange
      }
    ]
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '/400',
    component: NotFound
  },
  {
    // 存在しないページへのアクセス
    path: '*',
    redirect: '/404'
  }
];
